/* eslint-disable semi */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import {
	H1,
	H2,
	H3,
	H4,
	H5,
	H6,
	Paragraph,
	OrderedList,
	UnorderedList,
	ListItem,
} from 'components/atoms/Typography';
import { Group } from 'components/atoms/Page';
import Link from 'components/atoms/Link/Link';
import './MarkdownWrapper.scss';

const markdownComponentMap = {
	h1: (props) => (
		<H1
			className="ss-type-large"
			{...props}
		/>
	),
	h2: (props) => (
		<div
			style={{ paddingBottom: 'inherit' }}
			className="card-title"
		>
			<H2
				className="ss-type-large"
				{...props}
			/>
		</div>
	),
	h3: (props) => (
		<H3
			size="mediumLarge"
			weight="bold"
			{...props}
		/>
	),
	h4: (props) => (
		<div
			style={{ paddingBottom: 'inherit' }}
			className="card-title"
		>
			<H4
				className="ss-type-medium"
				{...props}
			/>
		</div>
	),
	h5: (props) => (
		<H5
			className="ss-type-small"
			{...props}
		/>
	),
	h6: (props) => (
		<div
			style={{ paddingBottom: 'inherit' }}
			className="card-title"
		>
			<H6
				className="ss-type-small"
				{...props}
			/>
		</div>
	),
	p: (props) => <Paragraph {...props} />,
	ol: (props) => <OrderedList {...props} />,
	ul: (props) => <UnorderedList {...props} />,
	li: (props) => <ListItem {...props} />,
	a: (props) => (
		<Link
			{...props}
			// tertiary={props.color === 'white'}
		/>
	),
	blockquote: (props) => (
		<div
			style={{ paddingLeft: '2.31rem' }}
			{...props}
		/>
	),
};

export default function MarkdownWrapper({
	content,
	components,
	componentProps,
	...args
}) {
	// Create component map with additional props if provided
	const createComponents = (baseComponents) => {
		if (!componentProps) return baseComponents;

		return Object.keys(baseComponents).reduce((acc, key) => {
			const Component = baseComponents[key];
			acc[key] = (props) => {
				// Merge className from componentProps and props to ensure both are applied
				const mergedClassName = [
					componentProps.className,
					props.className,
				]
					.filter(Boolean)
					.join(' ');
				return (
					<Component
						{...componentProps}
						{...props}
						className={mergedClassName || undefined}
					/>
				);
			};
			return acc;
		}, {});
	};

	const mergedComponents = {
		...createComponents(markdownComponentMap),
		...createComponents(components || {}),
	};

	return (
		<div className="markdown-wrapper">
			{content &&
				content.map((item) => (
					<Group key={item.value}>
						<ReactMarkdown
							components={mergedComponents}
							{...args}
						>
							{item.value}
						</ReactMarkdown>
					</Group>
				))}
		</div>
	);
}

MarkdownWrapper.propTypes = {
	content: PropTypes.arrayOf(PropTypes.object),
	components: PropTypes.objectOf(PropTypes.Component),
	componentProps: PropTypes.object,
	className: PropTypes.string,
};
